<rx-intuitive-order-layout>
	<rx-procedure-button
		slot="procedure-button"
		[selectedProcedure]="selectedProcedure$ | async"
		[expanded]="proceduresSelectExpanded"
		[canExpand]="canChangeProcedure$ | async"
		[readOnly]="!!(isReadOnly$ | async)"
		[animationElement]="expansionPanelRef"
		[disabled]="isProcedureSelectionReadOnly$ | async"
		(buttonClicked)="showSelectPanel()"
	></rx-procedure-button>

	<rx-favorite-selector
		*ngIf="(sendToState$ | async)?.isVisible"
		slot="send-to"
		tlkCardContent
		data-testid="order-send-to-lab"
		class="intuitive-inline-card__content"
		[id]="'sendTo'"
		[label]="'OrderSection.SendTo' | translate"
		[formControl]="sendToControl"
		[options]="availableLabs$ | async"
		name="sendToControl"
		[isCancellable]="!!(isSendToCancellable$ | async)"
		[isDisabled]="!(sendToState$ | async)?.isEnabled || !!(isReadOnly$ | async)"
		[isRequired]="!!(sendToState$ | async)?.isRequired"
		[isReadOnly]="!!(isReadOnly$ | async)"
		[favoriteName]="favoriteSendTo"
		[enableSimpleMode]="!!(isNotDoctor$ | async)"
	></rx-favorite-selector>

	<rx-due-date-picker
		*ngIf="(dueDateState$ | async)?.isVisible"
		slot="due-date"
		tlkCardContent
		class="intuitive-inline-card__content"
		[isRequired]="!!(dueDateState$ | async)?.isRequired"
		[formControl]="dueDateControl"
		[isCancellable]="!(dueDateState$ | async)?.isRequired"
		[isReadOnly]="!!(isReadOnly$ | async)"
		[minimalAvailableDueDate]="minimalAvailableDueDate$ | async"
		[useIntuitiveCalendarIcon]="true"
		name="dueDateControl"
		[rxIsDisabled]="!(dueDateState$ | async)?.isEnabled"
		(rxIsDisabledEvent)="clearControl(dueDateControl)"
	></rx-due-date-picker>
</rx-intuitive-order-layout>

<tlk-expansion-area [expanded]="proceduresSelectExpanded" [removeWhenCollapsed]="false">
	<ng-template tlkExpansionContent>
		<div #expansionPanel class="expansion-panel-wrapper">
			<tlk-card [padding]="0" class="select-procedure-panel">
				<rx-procedure-tiles
					tlkCardContent
					[procedures]="procedures$ | async"
					[selectedProcedureId]="(selectedProcedureId$ | async) ?? null"
					(procedureChanged)="onProcedureChanged($event)"
					(changeProcedureCancelled)="onChangeProcedureCancelled()"
					[promptOnChange]="true">
				</rx-procedure-tiles>
			</tlk-card>
		</div>
	</ng-template>
</tlk-expansion-area>
